/**
 * Every path in one place, so a link and the route that answers it cannot
 * drift apart. The two public routes are listed with the rest deliberately:
 * they are part of the same application, they simply do not need a session.
 */
export const routes = {
  /* Marketing and legal */
  home: '/',
  pricing: '/pricing',
  premium: '/premium',
  /** Where Paddle sends the browser after a completed checkout from the pricing page. */
  welcome: '/welcome',
  terms: '/terms',
  privacy: '/privacy',
  refunds: '/refunds',

  /* The tutor's app */
  app: '/user',
  login: '/user/login',
  dashboard: '/user',
  students: '/user/students',
  ensembles: '/user/ensembles',
  studentEditor: '/user/students/:name/edit',
  studentProfile: '/user/students/:name',
  contacts: '/user/contacts',
  calendar: '/user/calendar',
  lessons: '/user/lessons',
  payments: '/user/payments',
  paymentDocuments: '/user/payment-documents',
  receipts: '/user/receipts',
  receiptReports: '/user/receipt-reports',
  business: '/user/business',
  openFormat: '/user/open-format',
  admin: '/user/admin',
  reminders: '/user/reminders',
  reports: '/user/reports',
  googleCalendar: '/user/google-calendar',
  backup: '/user/backup',
  profile: '/user/profile',
  premiumArea: '/user/premium',

  /* Public, token-addressed. Whoever opens one has no account here. */
  paymentRequest: '/pay/:token',
  intakeForm: '/intake/:token'
} as const;

/** Fills the parameters of a route pattern, encoding each value. */
export function toPath(pattern: string, params: Record<string, string | number>): string {
  return pattern.replace(/:([A-Za-z]+)/g, (match, key: string) => {
    const value = params[key];
    return value === undefined ? match : encodeURIComponent(String(value));
  });
}
